import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/industries/ai-data/page.tsx");
